<template>
    <div>
        <div v-if="authUserPermission['manufacture-view']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>      
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('manufacture') }}</h3>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="table.search" :placeholder="tt('search_manufacture')" v-on:keyup="filter"/>                            
                                </div>
                            </div>
                            <div class="col text-right">
                                <base-button size="sm" type="default" @click="create" v-if="authUserPermission['manufacture-create']">{{ tt('add_manufacture') }}</base-button>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="350px" class="table-responsive table-flush" header-row-class-name="thead-light" :data="table.data" v-if="!onLoad">
                            <el-table-column :label="tt('code')" :prop="tt('code')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.manufacture_code}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('manufacture')" :prop="tt('manufacture')" min-width="350px" sortable>
                                <template v-slot="{row}">
                                    {{row.manufacture_name}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('country')" :prop="tt('country')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.country}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('business_type')" :prop="tt('business_type')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.business_type}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('address')" :prop="tt('address')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.address}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('phone')" :prop="tt('phone')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.business_phone}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('fax')" :prop="tt('fax')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.fax}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('mobile_phone')" :prop="tt('mobile_phone')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.mobile_phone}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('email')" :prop="tt('email')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.email}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('contact_person')" :prop="tt('contact_person')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    {{row.contact_person}}
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('notes')" :prop="tt('notes')" min-width="140px" sortable>
                                <template v-slot="{row}">
                                    {{row.notes}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="action" width="100">
                                <template v-slot="{row}">
                                    <el-dropdown trigger="click" class="dropdown" @command="handleTableAction" :hide-on-click="true">
                                        <span class="btn btn-sm btn-icon-only text-light">
                                            <i class="fas fa-ellipsis-v mt-2"></i>
                                        </span>
                                        <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                                            <el-dropdown-item :command="{action:'edit', data:row.id}">{{ tt('edit') }}</el-dropdown-item>
                                            <el-dropdown-item :command="{action:'remove', data:row.id}">{{ tt('delete') }}</el-dropdown-item>                                        
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>      
                    <div class="card-footer pb-0 ">   
                        <span class="float-left">
                            <base-pagination :page-count="table.page.last_page" v-model="table.page.current_page" @click.native="changePage(table.page.current_page)" size="sm"></base-pagination>
                        </span>                             
                        <span class="float-right">
                            {{ tt('page_info', {size: (table.page.current_page - 1) * table.page.per_page + table.data.length, total: table.total}) }}
                        </span>
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="form.show">
                    <template slot="header">
                        <h5 class="modal-title">{{form.title}}</h5>
                    </template>
                    <div>
                        <base-alert type="danger" v-if="errorMessage">
                            <p><strong>{{ errorMessage.message }}</strong></p>
                            <div v-if="errorMessage.data.length != 0">
                                <span v-for="message in errorMessage.data">
                                    {{ message[0] }}<br>
                                </span>
                            </div>
                        </base-alert>
                        
                        <label class="form-control-label">{{ tt('manufacture_code') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('manufacture_code')" :placeholder="tt('manufacture_code')" v-model="manufacture.manufacture_code" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('manufacture_name') }} <span class="text-danger">*</span></label>
                        <base-input :name="tt('manufacture_name')" :placeholder="tt('manufacture_name')" v-model="manufacture.manufacture_name" rules="required"></base-input>

                        <label class="form-control-label">{{ tt('country') }}</label>
                        <base-input :name="tt('country')" :placeholder="tt('country')" v-model="manufacture.country"></base-input>

                        <label class="form-control-label">{{ tt('business_type') }}</label>
                        <base-input :name="tt('business_type')" :placeholder="tt('business_type')" v-model="manufacture.business_type"></base-input>

                        <label class="form-control-label">{{ tt('address') }}</label>
                        <base-input :name="tt('address')" :placeholder="tt('address')" v-model="manufacture.address"></base-input>

                        <label class="form-control-label">{{ tt('phone') }}</label>
                        <base-input :name="tt('phone')" :placeholder="tt('phone')" v-model="manufacture.business_phone"></base-input>

                        <label class="form-control-label">{{ tt('fax') }}</label>
                        <base-input :name="tt('fax')" :placeholder="tt('fax')" v-model="manufacture.fax"></base-input>

                        <label class="form-control-label">{{ tt('mobile_phone') }}</label>
                        <base-input :name="tt('mobile_phone')" :placeholder="tt('mobile_phone')" v-model="manufacture.mobile_phone"></base-input>

                        <label class="form-control-label">{{ tt('email') }}</label>
                        <base-input :name="tt('email')" :placeholder="tt('email')" v-model="manufacture.email"></base-input>

                        <label class="form-control-label">{{ tt('contact_person') }}</label>
                        <base-input :name="tt('contact_person')" :placeholder="tt('contact_person')" v-model="manufacture.contact_person"></base-input>

                        <label class="form-control-label">{{ tt('notes') }}</label>
                        <base-input :name="tt('notes')" :placeholder="tt('notes')" v-model="manufacture.notes"></base-input>

                    </div>
                    <template slot="footer">
                        <base-button type="secondary" @click="form.show = false">{{ tt('close') }}</base-button>
                        <base-button type="primary" v-on:click="save" :disabled="btnSave.onLoading || invalid">
                            <span v-if="btnSave.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span v-if="form.add">{{ tt('add') }}</span>
                                <span v-else>{{ tt('edit') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        </div>
        <noaccess v-else/>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import Api from '@/helpers/api';
    import manufacture from '@/services/dictionary/manufacture.service';

    export default {        
        data() {
            return {
                onLoad: true,      
                loadTimeout: null,  
                btnSave: {
                    onLoading: false
                },
                form: {
                    title: this.tt('add_manufacture'),
                    show: false
                },
                table: {
                    search: '',                    
                    total: 0,
                    data: [],
                    page: [],
                },     
                errorMessage: null,   
                manufacture: {},
            }
        },
        computed: {
            ...mapState({
                authUserPermission :state => state.auth.userPermission
            }),
        },
        mounted() {
            this.get()
        },
        methods: {
            get() { 
                let context = this;               
                Api(context, manufacture.get(this.table.page.current_page, {search: this.table.search})).onSuccess(function(response) {    
                    context.table.total = response.data.data.data.total;
                    context.table.data = response.data.data.data.data; 
                    context.table.page  = response.data.data.data; 
                    context.onLoad = false;          
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.table.data = [];
                        context.table.total = 0;
                        context.onLoad = false;
                    }
                })
                .call()
            },
            filter() {
                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 1000);
            },
            handleTableAction(command) {
                switch (command.action) {
                    case 'edit':
                            this.edit(command.data);
                        break;
                    case 'remove':
                            this.remove(command.data);
                        break;
                    default:
                        break;
                }
            },
            create() {
                this.errorMessage = null;
                this.form.add = true;
                this.form.title = this.tt('add_manufacture');
                this.form.show = true;
                this.manufacture = {};
            },            
            edit(id) {
                this.errorMessage = null;
                let context = this;               
                Api(context, manufacture.show(id)).onSuccess(function(response) {
                    context.manufacture = response.data.data;
                    context.form.add = false;
                    context.form.title = context.tt('edit_manufacture');
                    context.form.show = true;                          
                })
                .call()        
            },
            save() {                      
                this.btnSave.onLoading = true;
                let api = null;
                let context = this;

                if (this.form.add) {
                    api = Api(context, manufacture.create(this.manufacture));
                } else {{
                    api = Api(context, manufacture.update(this.manufacture.id, this.manufacture));
                }}
                api.onSuccess(function(response) {
                    context.get();
                    context.$notify({
                        message: response.data.message,                  
                        type: 'success',
                        verticalAlign: 'bottom', 
                        horizontalAlign: 'left'
                    });
                    context.form.show = false;
                }).onError(function(error) {                    
                    context.errorMessage = error.response.data;
                }).onFinish(function() {
                    context.btnSave.onLoading = false;   
                })
                .call();
            },
            remove(id) {
                this.confirmDialog(this.tt('confirm_delete')).then((result) => {
                    let context = this;
                    if (result.value) {
                        Api(context, manufacture.delete(id)).onSuccess(function(response) {
                            context.$notify({
                                message: response.data.message,
                                type: 'success',
                                verticalAlign: 'bottom', 
                                horizontalAlign: 'left'
                            });
                            context.get();
                        }).call();
                    }
                })
            },
            changePage(page) {
                let context = this;
                context.onLoad = true;

                clearTimeout(this.loadTimeout);
                this.loadTimeout = setTimeout(() => {
                    this.get()
                }, 100);
            },
        }   
    };
</script>
<style></style>
